import { render } from "./AppInstall.vue?vue&type=template&id=4a7006c5&scoped=true"
import script from "./AppInstall.vue?vue&type=script&lang=js"
export * from "./AppInstall.vue?vue&type=script&lang=js"

import "./AppInstall.vue?vue&type=style&index=0&id=4a7006c5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7006c5"]])

export default __exports__